import "@/App.css";
import "@/lib/adminAuthInterceptor";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import AdminLogin from "@/pages/AdminLogin";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AdminLayout from "@/layouts/AdminLayout";
import DashboardPage from "@/pages/admin/DashboardPage";
import CategoriesPage from "@/pages/admin/CategoriesPage";
import ProductsPage from "@/pages/admin/ProductsPage";
import BannersPage from "@/pages/admin/BannersPage";
import PaymentMethodsPage from "@/pages/admin/PaymentMethodsPage";
import HighlightPage from "@/pages/admin/HighlightPage";
import StoreLocationsPage from "@/pages/admin/StoreLocationsPage";
import StoreDetailsPage from "@/pages/admin/StoreDetailsPage";import OrdersPage from "@/pages/admin/OrdersPage";
import UsersPage from "@/pages/admin/UsersPage";
import UserDetailsPage from "@/pages/admin/UserDetailsPage";
import OrderDetailPage from "@/pages/admin/OrderDetailPage";
import SettingsPage from "@/pages/admin/SettingsPage";
import DeliveryManagersPage from "@/pages/admin/DeliveryManagersPage";

// Auth check
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("ecomdemo_token");
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="masters/categories" element={<CategoriesPage />} />
            <Route path="masters/products" element={<ProductsPage />} />
            <Route path="masters/banners" element={<BannersPage />} />
            <Route path="masters/payment-methods" element={<PaymentMethodsPage />} />
            <Route path="masters/highlight" element={<HighlightPage />} />
            <Route path="stores" element={<StoreLocationsPage />} />
            <Route path="stores/:storeId" element={<StoreDetailsPage />} />
            <Route path="orders" element={<OrdersPage />} />
            <Route path="orders/:orderId" element={<OrderDetailPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="users/:userId" element={<UserDetailsPage />} />
            <Route path="delivery-managers" element={<DeliveryManagersPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
